import React from "react";
import { useI18n } from "@/i18n";
import { useReveal } from "@/hooks/useReveal";
import RevealOnView from "@/components/site/RevealOnView";

const Icon = ({ i }) => {
  const common = "w-5 h-5";
  switch (i) {
    case 0:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7h18" /><path d="M6 7v13h12V7" /><path d="M9 7V4h6v3" /></svg>
      );
    case 1:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="14" rx="2" /><path d="M3 8h18" /><path d="M8 12h2" /></svg>
      );
    case 2:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3 6 6 .9-4.5 4.2 1 6.4L12 16.9 6.5 19.5l1-6.4L3 8.9 9 8z" /></svg>
      );
    case 3:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
      );
    case 4:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M4 17l5-5 4 4 7-7" /><path d="M14 9h6v6" /></svg>
      );
    default:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21s-7-4.5-7-11a5 5 0 019-3 5 5 0 019 3c0 6.5-7 11-7 11z" /></svg>
      );
  }
};

export default function Benefits() {
  const { t } = useI18n();
  const header = useReveal();

  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="relative py-24 md:py-36 bg-[color:var(--wf-surface)] border-t border-b border-neutral-200"
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div
          ref={header.ref}
          className={`reveal ${header.visible ? "is-visible" : ""} grid grid-cols-1 md:grid-cols-12 gap-8 md:items-end`}
        >
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 mb-5">
              <span
                className="inline-block w-6 h-px align-middle mr-3"
                style={{ background: "#c9a86a" }}
              />
              {t.benefits.eyebrow}
            </div>
            <h2
              data-testid="benefits-title"
              className="font-display text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] tracking-[-0.02em] font-light text-neutral-950"
            >
              {t.benefits.title}
            </h2>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-200 border border-neutral-200 rounded-[12px] overflow-hidden">
          {t.benefits.items.map((b, i) => (
            <RevealOnView
              key={b.title}
              data-testid={`benefit-item-${i}`}
              className="bg-white p-8 md:p-10 flex flex-col gap-5 transition-colors duration-500 hover:bg-[color:var(--wf-surface)]"
            >
              <div
                className="w-10 h-10 rounded-full grid place-items-center text-neutral-900"
                style={{
                  border: "1px solid rgba(201,168,106,0.45)",
                  background: "rgba(201,168,106,0.08)",
                }}
                aria-hidden
              >
                <Icon i={i} />
              </div>
              <h3 className="font-display text-[20px] md:text-[22px] tracking-[-0.01em] font-medium text-neutral-950">
                {b.title}
              </h3>
              <p className="text-neutral-600 leading-relaxed text-[15px]">
                {b.body}
              </p>
            </RevealOnView>
          ))}
        </div>
      </div>
    </section>
  );
}
